export default {
    MOVIE_API_URL: process.env.MOVIE_API_URL || "https://www.omdbapi.com/?apikey=",
    MOVIE_API_KEY: process.env.MOVIE_API_KEY || "973ec957",
    MOVIE_DATABASE_URL: process.env.MOVIE_DATABASE_URL || "https://desolate-reef-04678.herokuapp.com/api"
}